import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';
import type { LegalPage } from '@/types';

export const useLegalsStore = defineStore('legals', () => {
    const legals = ref<LegalPage[]>([]);
    const loadingFlag = ref<boolean>(false);
    function toResetLegals() {
        legals.value = [];
    }
    const awaitGetLegals = async (code: string) => {
        loadingFlag.value = true;
        try {
            const response = await axios.get<LegalPage[]>(`/main-api/legal-pages?language_code=${code}`);
            if (response.status === 200) {
                legals.value = response.data.map((item) => ({
                    ...item,
                    // path: `#${item.title.toLowerCase().replace(/ /g, '_')}_${item.id}`,
                    path: `#${item.id}`,
                    loadingItem: false
                })) as LegalPage[];
            }
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            loadingFlag.value = false;
        }
    };
    const awaitGetLegal = async (id: number, code: string) => {
        try {
            const response = await axios.get<LegalPage>(`/main-api/legal-pages/${id}?language_code=${code}`);
            if (response.status === 200) {
                const selectedLegal = legals.value.find((legal) => legal.id === id);
                if (selectedLegal) {
                    selectedLegal.content = response.data.content;
                    selectedLegal.title = response.data.title;
                    // selectedLegal.path = `#${selectedLegal.title.toLowerCase().replace(/ /g, '_')}_${selectedLegal.id}`;
                    selectedLegal.path = `#${selectedLegal.id}`;
                }
            }
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    return { legals, loadingFlag, toResetLegals, awaitGetLegals, awaitGetLegal };
});
